import React from 'react';

import { ConfigProvider } from '@app/ui';
import customTheme from '../../constants/theme';
import MvcRefreshProvider from './MvcRefreshContext';
import Notifications from '../notifications';
import { useAntdLocale } from '../../utils/antdLocale';

type BareContainerProps = {
    children: React.ReactNode;
};

/**
 * Authenticated container WITHOUT the app sidebar/header chrome — same providers
 * (theme, locale, refresh, notifications) and global client store as the normal
 * PrivateContainer, but renders children full-screen. For pages that bring their
 * own navigation (e.g. the full-screen API docs explorer).
 */
const BareContainer = ({ children }: BareContainerProps) => {
    const locale = useAntdLocale();

    return (
        <MvcRefreshProvider>
            <ConfigProvider theme={customTheme} locale={locale}>
                {children}
                <Notifications />
            </ConfigProvider>
        </MvcRefreshProvider>
    );
};

export default BareContainer;
